import urlParse from 'url-parse';

import config from '../config';
import { getCurrentTeamUrl } from './store-service';
import { browserHistory } from './history';

export const navigate = (url, event) => {
    const urlProps = urlParse(url);

    if (urlProps && (urlProps.hostname === `${getCurrentTeamUrl()}.${config.APP_DOMAIN}` || urlProps.hostname === config.APP_DOMAIN)) {
        browserHistory.push(urlProps.pathname);
        event && event.preventDefault();
    }
}
